<template>
    <div class="popupconfirm">
        <div class="modal fade " id="showModalConfirm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
              <div class="ui segment">
              <i id="spanClose" class="close icon grey" data-dismiss="modal" aria-label="Close"></i>
                  <p class="ui text large color black text-center"><strong>{{msg.title}}</strong></p>
                  <div class>
                      <p class="ui text large color black text-center">{{msg.message}}</p>
                  </div>
                  <div class="row mt-3">
                      <div class="col-6"><a data-dismiss="modal" aria-label="Close" class="ui button basic text col-12"><span class="ui text large">{{btnCancel}}</span></a></div>
                      <div class="col-6"><a @click="$parent.confirmRemove = true" data-dismiss="modal" aria-label="Close"  class="ui button teal text col-12"><span class="ui text large">{{btnConfirm}}</span></a></div>
                  </div>
                  <span id="hiddenConfirm" @click="$emit('close')"></span>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'popupconfirm',
    components: {},
    props: {
        msg: {
            type: Object,
            default: {
              title: 'ยืนยันทำรายการ',
              message: 'ต้องการทำรายการหรือไม่'
            }
        },
        btnCancel: {
            type: String,
            default: 'ยกเลิก'
        },
        btnConfirm: {
            type: String,
            default: 'ยืนยัน'
        },
    },
    data () {
        return {
          isActive: false,
        }
    },
    computed: {},
    mounted () {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.modal-dialog{
    top: 100px !important;
}
</style>